import {
  type AssignmentV2_UserAssignment,
  type AssignmentV2_GetUserAssignmentConversationsResponse_TicketListItem as AssignmentTaskItem,
  type AssignmentV2_GetUserAssignmentConversationsRequest,
  AssignmentV2_GetUserAssignmentConversationsResponse_ConversationStatus as ConversationStatus,
} from '@zendesk/zqa-services/assignments_v2'
import { SortValues } from '@/modules/tasks/utils/assignmentOptions'
import { type CalibrationSession } from '@/api/calibration'

export interface TasksListParams extends Partial<
  Omit<AssignmentV2_GetUserAssignmentConversationsRequest, 'limit' | 'seed'>
> {
  page: number
  limit: number
  revieweeId?: number
  botRevieweeId?: string
  reviewerId?: number
  reviewed?: boolean
  sort: SortValues
  status: ConversationStatus | 'ALL'
}

export interface State {
  activeAssignment?: Omit<
    AssignmentV2_UserAssignment,
    'goal' | 'personalGoal' | 'reviewCount' | 'personalReviewCount' | 'cycleEnd'
  >
  activeCalibrationSession?: CalibrationSession
  allCalibrationSessions: CalibrationSession[] | undefined
  listParams: TasksListParams
  changedListItem?: AssignmentTaskItem[]
  replaceReason?: string
}

export const defaultState: State = {
  activeAssignment: {
    id: '',
    name: '',
    settings: undefined,
    isReviewer: false,
  },
  activeCalibrationSession: {
    sessionId: null,
    title: '',
    dueAt: '',
    createdBy: null,
    createdAt: '',
    updatedBy: null,
    updatedAt: '',
  },
  allCalibrationSessions: [],
  changedListItem: [],
  listParams: {
    page: 0,
    limit: 100,
    revieweeId: 0,
    reviewerId: 0,
    reviewed: false,
    sort: SortValues.NEWEST,
    status: ConversationStatus.TODO,
  },
  replaceReason: null,
}
